export default {
    meta: {
        title: '设置',
    },
};
